<template>
  <div class="teacher-edit">
    <div class="title">基本信息</div>
    <Form
      class="form"
      ref="form"
      :model="form"
      :rules="formRules"
      label-position="right"
      :label-width="120"
    >
      <FormItem label="讲师名称：" prop="real_name">
        <Input v-model="form.real_name" placeholder="请输入讲师姓名，最多不超过15个字" clearable :maxlength="15"></Input>
        <!-- <Button
          class="btn-form btn-select-student"
          @click="onSelectStudent"
          v-if="!teacherID"
        >+ 选择学员</Button>-->
      </FormItem>
      <FormItem label="讲师手机号：" prop="mobile">
        <Input v-model="form.mobile" placeholder="请输入讲师手机号" :disabled="disable" clearable></Input>
      </FormItem>

      <FormItem label="所属分类" prop="classify_ids">
        <Cascader
          :data="catagoris"
          trigger="hover"
          v-model="form.classify_ids"
          change-on-select
          style="width:200px;"
        ></Cascader>
      </FormItem>
      <FormItem label="讲师头像：" prop="avatar">
        <div class="upload-avatar-box">
          <div class="avatar" v-show="form.avatar">
            <img :src="form.avatar" />
          </div>
          <UploadFile
            url="/api/public/img"
            :format="['jpg','jpeg','png']"
            :primary="false"
            note="300*300像素或1:1，支持jpg、jpeg、png,小于5M"
            @onSuccess="onUploadSuccess"
          ></UploadFile>
        </div>
      </FormItem>
      <FormItem label="讲师介绍：" prop="introduction">
        <Input
          class="introduction"
          type="textarea"
          :rows="4"
          v-model="form.introduction"
          placeholder="请输入讲师介绍，最多不超过200个字"
          :maxlength="200"
          clearable
        ></Input>
        <CharCount :max="200" :text="form.introduction"></CharCount>
      </FormItem>
      <AttrSelect form-url="/api/module/attribute/3" :attr="form.attr" @onChange="onAttrChange"></AttrSelect>
      <FormItem>
        <Button class="btn-form btn-margin-right" type="primary" size="large" @click="onSave">保存</Button>
      </FormItem>
    </Form>
    <Modal v-model="showSelectStudent" title="选择学员" @on-ok="onConfirmSelectStudent" width="800">
      <StudentSelect ref="student" selectType="single"></StudentSelect>
    </Modal>
  </div>
</template>

<script>
import AttrSelect from "@/components/AttrSelect";
import StudentSelect from "@/components/GridSelect/StudentSelect";
import UploadFile from "@/components/UploadFile";

export default {
  name: "teacher-edit",
  components: {
    AttrSelect,
    StudentSelect,
    UploadFile
  },
  data() {
    return {
      catagoris: [],
      form: {
        real_name: "",
        mobile: "",
        avatar: "",
        introduction: "",
        teacher_attr: "",
        classify_id: "",
        parent_classify_id: "",
        attr: []
      },
      formRules: {
        real_name: [{ required: true, message: "姓名不能为空" }],
        classify_ids: [{ required: true, message: "所属分类不能为空" }],
        mobile: [{ required: true, message: "手机号不能为空" }],
        avatar: [{ required: true, message: "请上传头像！" }],
        introduction: [{ required: true, message: "请输入简介！" }]
      },
      teacherID: this.$route.query.id,
      showSelectStudent: false,
      disable: false
    };
  },
  created() {
    this.requestCategories();
    if (this.teacherID) {
      this.requestDetail();
    }

  },
  methods: {
    async requestCategories()
    {
      let catagoris = await this.$http.get("/api/course/classify");
      this.catagoris = catagoris;
    },

    // on-event
    onUploadSuccess(data) {
      this.form.avatar = data.path;
    },
    onSelectStudent() {
      this.showSelectStudent = true;
    },
    onConfirmSelectStudent() {
      const list = this.$refs.student.getSelectList();
      if (!list.length) return;
      const data = list[0];
      this.form.real_name = data.nickname;
      this.form.mobile = data.mobile;
      this.form.avatar = data.avatar;
      this.disable = true;
    },
    onAttrChange(val) {
      this.form.teacher_attr = val;
    },
    onSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.form.classify_id = this.form.classify_ids[1] || this.form.classify_ids[0];
        this.form.parent_classify_id = this.form.classify_ids[0];
        if (this.teacherID) {
          // 编辑
          this.$http
            .put("/api/teacher/" + this.teacherID, this.form)
            .then(() => {
              this.$Message.success("编辑成功");
              setTimeout(() => {
                this.$router.back();
              }, 1000);
            });
        } else {
          // 新增
          this.$http.post("/api/teacher", this.form).then(() => {
            this.$Message.success("新增成功");
            setTimeout(() => {
              this.$router.back();
            }, 1000);
          });
        }
      });
    },
    // other
    // request
    requestDetail() {
      this.$http.get("/api/teacher/" + this.teacherID).then(data => {
        this.form = data;
        let catagoris = this.catagoris;
        this.form.classify_ids = [data.classify_id, 0];
        for (let i = 0; i < catagoris.length; i++) {
          let catagory = catagoris[i];
          let c = 0;
          if( catagory.children ) {
            for (; c < catagory.children.length; c++) {
              let child = catagory.children[c];
              console.log( child );
              if (child.id == data.classify_id) {
                this.form.classify_ids = [catagory.id, child.id];
                break;
              }
            }
            if (c < catagory.children.length) {
              break;
            }
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.teacher-edit {
  .form {
    width: 500px;
  }
  .ivu-form-item {
    width: 620px;
    .ivu-form-item-content {
      span {
        float: right;
      }
    }
  }
  .introduction {
    width: 500px;
  }
  .btn-form {
    width: 100px;
  }
  .btn-select-student {
    position: absolute;
    top: 1px;
    left: 400px;
  }
}
</style>
